import {createContext, Dispatch, SetStateAction, useMemo, useState} from 'react'

export interface ISpinnerStatusContext {
    spinnerStateCounter: number
    setSpinnerStateCounter?: Dispatch<SetStateAction<number>>
}

export const SpinnerStatusContext = createContext<ISpinnerStatusContext>({
    spinnerStateCounter: 0
});

interface SpinnerStatusContextProviderProps {
    children: React.ReactNode;
}

/**
 * A context provider component for managing a system-wide spinner.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The children components.
 *
 * @returns {React.ReactNode} - The rendered React node.
 */
export function SpinnerStatusContextProvider({children} : Readonly<SpinnerStatusContextProviderProps>)
{
    /**
     * Keeps track of activities for which the spinner should be shown. If an activity is started, the counter should
     * be increased by one and after the activity
     */
    const [spinnerStateCounter, setSpinnerStateCounter] = useState<number>(0);

    const exposedData = useMemo<ISpinnerStatusContext>(() => {
        const context : ISpinnerStatusContext =
        {
            spinnerStateCounter : spinnerStateCounter,
            setSpinnerStateCounter : setSpinnerStateCounter,
        }

        return context;
    }, [spinnerStateCounter]);

    return(
        <SpinnerStatusContext.Provider value = {exposedData}>
            {children}
        </SpinnerStatusContext.Provider>
    )
}